import React from 'react';

const Footer = () => (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-gray-300 border-t border-gray-700 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
                {/* About Section */}
                <div>
                    <h3 className="text-white font-bold text-lg mb-3">Apex Chess Academy</h3>
                    <p className="text-sm text-gray-400 leading-relaxed">
                        Excellence in chess education. Nurturing strategic minds and champions of tomorrow.
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">Quick Links</h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <a href="https://apexchess.academy/about-team" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors">
                                About Us
                            </a>
                        </li>
                        <li>
                            <a href="https://apexchess.academy/stories" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors">
                                Success Stories
                            </a>
                        </li>
                        <li>
                            <a href="https://apexchess.academy/contact" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors">
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>

                {/* Contact Info */}
                <div>
                    <h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">Contact</h4>
                    <div className="space-y-2 text-sm text-gray-400">
                        <p className="flex items-center gap-2">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            apexchessacademy@gmail.com
                        </p>
                        <p className="flex items-center gap-2">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                            +91 8866888640
                        </p>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="mt-8 pt-6 border-t border-gray-700 text-center">
                <p className="text-sm text-gray-400">
                    &copy; {new Date().getFullYear()} Apex Chess Academy. All rights reserved.
                </p>
                <p className="text-xs text-gray-500 mt-2">
                    Built with ♟️ for excellence in chess education
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
